<template>
  <div class="finance-income">
    <div class="ly-card">
      <ul class="list">
        <li>
          <div class="title">统计时间</div>
          <div class="content flex-1">
            <el-date-picker
              v-model="date"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </div>
          <el-button type="primary" @click.native="search">查询</el-button>
          <el-button type="primary">导出</el-button>
        </li>
        <li>
          <div class="title">订单归属</div>
          <div class="content">
            <el-input placeholder="所属部门"></el-input>
            <el-input placeholder="所属项目"></el-input>
            <el-input placeholder="所属班级"></el-input>
          </div>
        </li>
      </ul>
    </div>
    <div class="ly-card">
      <ly-table
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        :searchFormData="searchFormData"
        ref="lyTable"
        class="width-full"
      >
      </ly-table>
    </div>
  </div>
</template>
<script>
import { DatePicker, Input } from 'element-ui';
import LyTable from '@/components/LyTable';
import { financeIncomeTable } from '@/utils/tableHeader';
import { finance } from '@/api';

export default {
  name: 'FinanceIncome',
  components: {
    ElDatePicker: DatePicker,
    ElInput: Input,
    LyTable
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      date: '',
      form: {
        pay_type: []
      },
      getTableData: finance.revenueStatistics,
      searchFormData: {},
      tableHeader: financeIncomeTable
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    search() {
      let tmp = {};
      if (this.date && this.date.length) {
        const [first_time, last_time] = this.date;
        tmp = {
          first_time,
          last_time
        };
      }
      this.searchFormData = { ...this.form, ...tmp };
      this.$refs.lyTable.setData();
    },
    changeMore() {
      this.isMore = !this.isMore;
      this.form = {
        pay_type: []
      };
    }
  }
};
</script>
<style lang="less">
.finance-income {
  .el-input {
    width: 220px;
    margin-right: 20px;
  }
  ul.list {
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      margin: 15px 0;
      display: flex;
      align-items: center;
      .title {
        margin-right: 20px;
      }
    }
  }
}
</style>
